(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[986],{

/***/ 2529:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contacto",
      function () {
        return __webpack_require__(78061);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contacto; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/components/Container/index.js + 1 modules
var Container = __webpack_require__(12556);
// EXTERNAL MODULE: ./src/components/Form/index.js + 19 modules
var Form = __webpack_require__(83544);
// EXTERNAL MODULE: ./src/components/ProtectedPage/index.js + 1 modules
var ProtectedPage = __webpack_require__(26212);
// EXTERNAL MODULE: ./src/components/Toaster/index.js + 4 modules
var Toaster = __webpack_require__(88675);
// EXTERNAL MODULE: ./node_modules/cookie-cutter/index.js
var cookie_cutter = __webpack_require__(49552);
var cookie_cutter_default = /*#__PURE__*/__webpack_require__.n(cookie_cutter);
;// CONCATENATED MODULE: ./src/lib/getHSCookie.js

var __HS_COOKIE_NAME__ = "hubspotutk";
var __HS_DEFAULT_COOKIE__ = "__nocookie__";
var isBrowser = function() {
    return "object" !== "undefined";
};
function getHSCookie() {
    var defaultCookie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (typeof defaultCookie !== "undefined" && defaultCookie !== "") {
        return defaultCookie;
    }
    if (isBrowser()) {
        return cookie_cutter_default().get(__HS_COOKIE_NAME__);
    }
    return __HS_DEFAULT_COOKIE__;
};

;// CONCATENATED MODULE: ./src/pages/contacto.js













function getSubmitData(values) {
    var cookie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", context = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var fields = [];
    Object.keys(values).forEach(function(field) {
        fields = (0,_to_consumable_array/* default */.Z)(fields).concat([
            {
                name: field,
                value: values[field]
            }, 
        ]);
    });
    var contextFinal = (0,_object_spread/* default */.Z)({}, context);
    if (cookie !== "" && cookie !== undefined) {
        contextFinal = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contextFinal), {
            hutk: cookie
        });
    }
    var now = new Date();
    return {
        submittedAt: now.valueOf(),
        fields: fields,
        context: contextFinal
    };
}
function submitFormHubSpot(formId, submitData, param) {
    var setSubmitting = param.setSubmitting, onSuccess = param.onSuccess, onError = param.onError;
    var formUrl = "https://api.hsforms.com/submissions/v3/integration/submit/".concat(formId);
    axios_default().post(formUrl, submitData).then(function() {
        setSubmitting(false);
        onSuccess();
    }).catch(function(error) {
        setSubmitting(false);
        onError(error);
    });
}
function submitForm(form, values, param) {
    var setSubmitting = param.setSubmitting, onSuccess = param.onSuccess, onError = param.onError, cookie = param.cookie;
    setSubmitting(true);
    var submitData = getSubmitData(values, getHSCookie(cookie), {
        pageUri: "socios.aibes.org",
        pageName: "Portal de socios"
    });
    // First, get the client IP address
    axios_default().get("https://api.ipify.org/").then(function(param) {
        var ip = param.data;
        submitFormHubSpot(form, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, submitData), {
            context: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, submitData.context), {
                ipAddress: ip
            })
        }), {
            setSubmitting: setSubmitting,
            onSuccess: onSuccess,
            onError: onError
        });
    }).catch(function() {
        submitFormHubSpot(form, submitData, {
            setSubmitting: setSubmitting,
            onSuccess: onSuccess,
            onError: onError
        });
    });
}
var contactFormValidationSchema = es/* object */.Ry({
    firstName: es/* string */.Z_().required("Este campo es requerido"),
    lastName: es/* string */.Z_().required("Este campo es requerido"),
    email: es/* string */.Z_().email("Debe incluir un correo electr\xf3nico v\xe1lido").required("Este campo es requerido"),
    phone: es/* string */.Z_().required("Este campo es requerido"),
    company: es/* string */.Z_().required("Este campo es requerido"),
    country: es/* string */.Z_().required("Este campo es requerido"),
    message: es/* string */.Z_().required("Este campo es requerido")
});
function ContactPage(param) {
    var user = param.user;
    var submitContactForm = (0,react.useCallback)(function(param) {
        var values = param.values, setSubmitting = param.setSubmitting, resetForm = param.resetForm;
        setSubmitting(true);
        var firstName = values.firstName, lastName = values.lastName, hsFormValues = (0,_object_without_properties/* default */.Z)(values, [
            "firstName",
            "lastName"
        ]);
        submitForm("7663692/a2179347-3705-49f7-a43e-961f18dd123e", (0,_object_spread/* default */.Z)({
            firstname: firstName,
            lastname: lastName
        }, hsFormValues), {
            setSubmitting: setSubmitting,
            onSuccess: function onSuccess() {
                resetForm();
                (0,Toaster/* notifySuccess */.t5)("El formulario ha sido enviado. Gracias por ponerse en contacto con nosotros.");
            },
            onError: function onError() {
                (0,Toaster/* notifyError */.cB)("Ha ocurrido un error al enviar el formulario. Por favor, int\xe9ntelo nuevamente.");
            }
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full py-10 lg:py-20 relative overflow-hidden bg-gradient-to-t from-white to-gray-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: "space-y-10 relative z-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 xl:gap-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:col-span-6 flex flex-col space-y-6 lg:space-y-10 text-lg lg:pt-20 xl:pt-32",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col space-y-4 lg:space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-xl lg:text-3xl xl:text-5xl font-semibold lg:font-bold lg:tracking-tight",
                                            children: "Cont\xe1ctenos"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-lg lg:text-xl text-gray-700",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "leading-relaxed",
                                                children: "Nuestro equipo estar\xe1 encantado de responder a tus preguntas sobre nuestro programa de socios. Completa el siguiente formulario y nos pondremos en contacto lo antes posible."
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "space-y-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-gray-600",
                                        children: [
                                            "Para consultas generales, incluidas oportunidades de asociaci\xf3n, env\xede un correo electr\xf3nico a\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "font-semibold text-gray-900 hover:text-green-500",
                                                href: "mailto:info@aibes.org",
                                                children: "info@aibes.org"
                                            }),
                                            "."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:col-span-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-white rounded-lg lg:rounded-xl shadow-lg lg:shadow-xl ring-1 ring-black ring-opacity-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "px-8 py-10 lg:px-10 lg:py-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.ZP, {
                                        initialValues: {
                                            firstName: user === null || user === void 0 ? void 0 : user.firstName,
                                            lastName: user === null || user === void 0 ? void 0 : user.lastName,
                                            email: user === null || user === void 0 ? void 0 : user.email,
                                            phone: "",
                                            company: "",
                                            country: "",
                                            message: ""
                                        },
                                        handleSubmit: submitContactForm,
                                        validationSchema: contactFormValidationSchema,
                                        validateOnMount: true,
                                        enableReinitialize: true,
                                        children: function() {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* FormContent */.fb, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "grid grid-cols-1 md:grid-cols-12 gap-4 lg:gap-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "md:col-span-6",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormFields */.Mt, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormField */.Wi, {
                                                                        label: "Nombres",
                                                                        fieldName: "firstName",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* TextField */.nv, {
                                                                            name: "firstName"
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "md:col-span-6",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormFields */.Mt, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormField */.Wi, {
                                                                        label: "Apellidos",
                                                                        fieldName: "lastName",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* TextField */.nv, {
                                                                            name: "lastName"
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "md:col-span-12",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* FormFields */.Mt, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormField */.Wi, {
                                                                            label: "Correo electr\xf3nico",
                                                                            fieldName: "email",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* EmailField */.s8, {
                                                                                name: "email"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormField */.Wi, {
                                                                            label: "Pa\xeds",
                                                                            fieldName: "country",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* CountrySelectField */.Ag, {
                                                                                name: "country"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "md:col-span-6",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormFields */.Mt, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormField */.Wi, {
                                                                        label: "Empresa",
                                                                        fieldName: "company",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* TextField */.nv, {
                                                                            name: "company"
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "md:col-span-6",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormFields */.Mt, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormField */.Wi, {
                                                                        label: "N\xfamero de tel\xe9fono",
                                                                        fieldName: "phone",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* TextField */.nv, {
                                                                            name: "phone"
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "md:col-span-12",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormFields */.Mt, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormField */.Wi, {
                                                                        label: "Mensaje",
                                                                        fieldName: "message",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* TextAreaField */.N7, {
                                                                            name: "message"
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-xs leading-relaxed text-gray-500",
                                                        children: [
                                                            "AIBES necesita la informaci\xf3n que proporcion\xf3 para comunicarse con usted acerca de nuestros productos y servicios. Puede darse de baja de estas comunicaciones en cualquier momento. Para obtener informaci\xf3n sobre c\xf3mo cancelar la suscripci\xf3n, as\xed como nuestras pr\xe1cticas de privacidad y el compromiso de proteger su privacidad, consulte nuestra\xa0",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "font-medium",
                                                                href: "https://www.aibes.org/legal/privacidad",
                                                                children: "Pol\xedtica de privacidad"
                                                            }),
                                                            "."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormActions */.iN, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormSubmit */.Ow, {
                                                            children: "Enviar mensaje"
                                                        })
                                                    })
                                                ]
                                            });
                                        }
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute inset-0 transform -skew-y-12 bg-gray-100 bg-gradient-to-tl from-green-100 via-gray-100 to-white flex flex-col items-end",
                style: {
                    height: "1100px",
                    top: "-500px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-24 w-3/12 bg-gradient-to-l from-green-500 to-green-500 z-20 absolute bottom-0 right-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-20 w-2/12 bg-gradient-to-l from-green-500 to-transparent z-20 absolute bottom-0 right-0 mb-24"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-14 w-3/12 bg-green-500 z-20 absolute bottom-0 left-0 -mb-14"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-10 w-2/12 border-t border-r border-green-500 z-20 absolute bottom-0 left-0"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var contacto = ((0,ProtectedPage/* withAuthenticatedUser */.c)(ContactPage, {
    doNotRedirectToLogin: true
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [741,774,888,179], function() { return __webpack_exec__(2529); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);